import { Link } from "react-router-dom";
import { COMPANY, SERVICES } from "../data";

export const Footer = () => (
  <footer className="bg-[#F5F4F1] border-t border-[#E4E1DA]" data-testid="main-footer">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-12">
      <div>
        <div className="flex items-center gap-3">
          <svg width="46" height="30" viewBox="0 0 150 90" fill="none">
            <path d="M12 14 H58 L12 76 H58" stroke="#2A5C2A" strokeWidth="9" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M76 76 V14 L104 52 L132 14 V76" stroke="#2A5C2A" strokeWidth="9" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          <span className="font-heading font-bold text-lg text-[#1A3C1A]">Zimmerei Müller</span>
        </div>
        <p className="mt-4 font-heading italic text-[#2A5C2A] text-lg">„{COMPANY.claim}"</p>
        <p className="mt-2 text-sm text-[#666666]">Ihr Zimmerei- und Dachdeckermeister im Spessart</p>
      </div>

      <div data-testid="footer-contact">
        <h4 className="font-condensed tracking-[0.2em] uppercase text-sm text-[#1A3C1A] font-semibold">Kontakt</h4>
        <ul className="mt-4 space-y-2 text-sm text-[#2A2A2A]">
          <li>Talstraße 5 · 97799 Zeitlofs-Weißenbach</li>
          <li><a href={`tel:${COMPANY.phoneLink}`} className="hover:text-[#2A5C2A] transition-colors">{COMPANY.phone}</a></li>
          <li><a href={`mailto:${COMPANY.email}`} className="hover:text-[#2A5C2A] transition-colors">{COMPANY.email}</a></li>
        </ul>
      </div>

      <div data-testid="footer-services">
        <h4 className="font-condensed tracking-[0.2em] uppercase text-sm text-[#1A3C1A] font-semibold">Leistungen</h4>
        <ul className="mt-4 space-y-2 text-sm text-[#2A2A2A]">
          {SERVICES.slice(0, 6).map((s) => (
            <li key={s.title}><a href="/#leistungen" className="hover:text-[#2A5C2A] transition-colors">{s.title}</a></li>
          ))}
        </ul>
        <div className="mt-5 flex gap-4 text-sm">
          <Link to="/impressum" className="text-[#2A5C2A] underline" data-testid="footer-link-impressum">Impressum</Link>
          <Link to="/datenschutz" className="text-[#2A5C2A] underline" data-testid="footer-link-datenschutz">Datenschutz</Link>
        </div>
      </div>
    </div>
    <div className="border-t border-[#E4E1DA] py-5 text-center text-sm text-[#666666]" data-testid="footer-copyright">
      © 2026 Zimmerei Müller GmbH &amp; Co. KG
    </div>
  </footer>
);
